import { useMutation } from '@tanstack/react-query';
import { NotificationMessage } from '../../../../../../components';
import * as service from '../services';
import { useSetupISACustomSegmentsStore } from '../SetupISACustomSegments.store';
import { useGetCustomSegmentTableList } from './useGetCustomSegmentTableList';

export const useRemoveCustomSegment = () => {
  const { setSetupISACustomSegmentsState } = useSetupISACustomSegmentsStore();
  const { handleChangeCustomSegmentPage } = useGetCustomSegmentTableList();

  const closeModal = () => {
    setSetupISACustomSegmentsState('openModalRemoveSegment', false);
    setSetupISACustomSegmentsState('selectedSegmentID', null);
  };

  const successAction = () => {
    closeModal();
    handleChangeCustomSegmentPage(1);
    NotificationMessage('success', 5000, 'Segmento removido com sucesso');
  };

  const errorAction = () => {
    closeModal();
    NotificationMessage('error', 5000, 'Erro ao remover segmento');
  };

  const removeSegmentMutation = useMutation({
    mutationFn: (payload: number) => service.deleteCustomSegment(payload),
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    handleRemoveSegmentMutation: removeSegmentMutation.mutate,
  };
};
